import {
  HomeView,
  ItemCreateView,
  ItemCreateSelectTypeView,
  ItemEditView,
  ItemsView,
  MapView,
  ReviewView,
  UserCreateView,
  UserEditView,
  UsersView,
  GatheringSpotsView,
  GatheringSpotTypeCreateView,
  GatheringSpotTypeEditView,
  GatheringSpotsSelectView,
  GatheringSpotTypesView,
  GatheringSpotsCreateSelectTypeView,
  GatheringSpotEditView,
  GatheringSpotCreateView,
} from '../pages';
import { type CustomRouteObject } from './types';

export const routesMain: CustomRouteObject[] = [
  /**
   * HOME ROUTES
   */
  {
    path: '/',
    element: <HomeView />,
    handle: { title: 'Home', icon: 'Home' },
  },

  /**
   * MAP ROUTES
   */
  {
    path: '/map',
    element: <MapView />,
    handle: { title: 'Map', icon: 'Map' },
  },

  /**
   * ITEMS ROUTES
   */
  {
    path: '/items',
    handle: { title: 'Items', icon: 'Sword' },
    children: [
      {
        path: '/items',
        element: <ItemsView />,
        handle: { title: 'All items', icon: 'Sword' },
      },
      {
        path: '/items/:item_id',
        element: <ItemEditView />,
        handle: { title: 'Edit item', icon: 'Sword' },
      },
      {
        path: '/items/create',
        handle: { title: 'Select item type', icon: 'Sword' },
        children: [
          {
            path: '/items/create',
            element: <ItemCreateSelectTypeView />,
          },
          {
            path: '/items/create/:item_type_id',
            element: <ItemCreateView />,
            handle: { title: 'Create item', icon: 'Sword' },
          },
        ],
      },
    ],
  },

  /**
   * GATHERING SPOTS ROUTES
   */
  {
    path: '/spots',
    handle: { title: 'Gathering spots', icon: 'Pin' },
    children: [
      {
        path: '/spots',
        element: <GatheringSpotsSelectView />,
      },
      {
        path: '/spots/spots',
        handle: { title: 'Gathering spots', icon: 'Pin' },
        children: [
          { path: '/spots/spots', element: <GatheringSpotsView /> },
          {
            path: '/spots/spots/:gathering_spot_id',
            element: <GatheringSpotEditView />,
            handle: { title: 'Edit gathering spot', icon: 'Pin' },
          },
          {
            path: '/spots/spots/create',
            handle: { title: 'Select type', icon: 'Pin' },
            children: [
              {
                path: '/spots/spots/create',
                element: <GatheringSpotsCreateSelectTypeView />,
              },
              {
                path: '/spots/spots/create/:gathering_spot_type_id',
                element: <GatheringSpotCreateView />,
                handle: { title: 'Create', icon: 'Pin' },
              },
            ],
          },
        ],
      },

      {
        path: '/spots/types',
        handle: { title: 'Gathering spot types', icon: 'Pin' },
        children: [
          {
            path: '/spots/types',
            element: <GatheringSpotTypesView />,
          },
          {
            path: '/spots/types/:gathering_spot_type_id',
            element: <GatheringSpotTypeEditView />,
            handle: { title: 'Edit gathering spot type', icon: 'Pin' },
          },
          {
            path: '/spots/types/create',
            element: <GatheringSpotTypeCreateView />,
            handle: { title: 'Create', icon: 'Pin' },
          },
        ],
      },
    ],
  },

  /**
   * USERS ROUTES
   */
  {
    path: '/users',
    element: <UsersView />,
    handle: { title: 'Users', icon: 'Friends' },
    children: [
      {
        path: '/users/create',
        element: <UserCreateView />,
        handle: { title: 'Create user', icon: 'Friends' },
      },
      {
        path: '/users/edit',
        element: <UserEditView />,
        handle: { title: 'Edit user', icon: 'Friends' },
      },
    ],
  },

  /**
   * REVIEW ROUTES
   */
  {
    path: '/review',
    element: <ReviewView />,
    handle: { title: 'Review', icon: 'Warning' },
  },
];

export const sidebar = routesMain.map(route => ({
  path: route.path,
  handle: route.handle,
}));
